import { LatLng, distanceTo, insideCircle } from "geolocation-utils";

type ICircle = { lat: number; lng: number; radius: number };

export const findCoordinateAt = (
  distance: number,
  coordinates: LatLng[],
  radius: number = 0
) => {
  let coordinate: LatLng | undefined = undefined;

  for (const [index, coord] of coordinates.entries()) {
    const passedCoords = coordinates.slice(0, index);

    const passedDistance = passedCoords.reduce((sum, currentCoord, i) => {
      const nextCoord = passedCoords.at(i + 1);

      const nextDistance = nextCoord ? distanceTo(currentCoord, nextCoord) : 0;
      return sum + nextDistance;
    }, 0);

    if (
      passedDistance >= distance &&
      !insideCircle(coordinates[0], coord, radius * 1000)
    ) {
      coordinate = coord;
      break;
    }
  }

  return coordinate;
};

export const calculateDistanceFor = (coordinates: LatLng[]) => {
  return coordinates.reduce((sum, item, index) => {
    const prevItem = coordinates[index - 1];
    const distnace = prevItem ? distanceTo(item, prevItem) : 0;
    return sum + distnace;
  }, 0);
};

export const distanceToCoordinate = (
  coordinate: LatLng,
  coordinates: LatLng[]
) => {
  const coordIndex = coordinates.findIndex(
    (item) => item.lat === coordinate.lat && item.lng === coordinate.lng
  );
  if (coordIndex > -1) {
    const slice = coordinates.slice(0, coordIndex);
    const distance = calculateDistanceFor(slice);
    return distance;
  }

  return 0;
};

export const isPointsInsideCircles = (circles: ICircle[], points: LatLng[]) => {
  return (
    points.filter((point) => {
      const isInside =
        circles.filter((circle) =>
          insideCircle(
            point,
            { lat: circle.lat, lng: circle.lng },
            circle.radius
          )
        ).length > 0;
      return isInside;
    }).length > 0
  );
};
